module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Outlet-4ac4ab906b1ce3976f283232cae5f75b.svg";